import * as Yup from 'yup';

export const VerificationSchema = Yup.object({
  verification: Yup.string()
    .required('This is a required field')
    .min(6, 'Verification must be 6 characters')
    .nullable(),
});
